import { SubmittalProps } from "@/interfaces/submittal_types";
import { SubmittalFormData } from "../SubmittalForm";

export function ImportSubmittalProps({ submittal }: { submittal: SubmittalProps; }): SubmittalFormData {
    return {
        submittal_id: submittal.submittal_id,
        received_date: submittal.received_date,
        sub_description: submittal.sub_description,
        project: { value: submittal.project, label: submittal.project_name ?? "" },
        assigned_to: { value: submittal.assigned_to_obj?.email ?? "", label: submittal.assigned_to_obj?.name ?? "" },
        assigned_by: { value: submittal.assigned_by_obj?.email ?? "", label: submittal.assigned_by_obj?.name ?? "" },
        category: { value: submittal.category, label: submittal.category },
        status: { value: submittal.status, label: submittal.status },
        completed_at: submittal.completed_at?.split("T")[0] ?? "", // No need for the time
        alert_status: submittal.alert_status,
        folder_location: submittal.folder_location,
    }
}
